(function(){
 if(window.__snrsShopifyCartRecommendations)return;
 window.__snrsShopifyCartRecommendations=true;
 var rootUrl=window.Shopify&&Shopify.routes&&Shopify.routes.root||'/';
 var warmedImages=new Map();
 var labels={},generation=0,cache=new Map(),resolved=new Map(),lastKey='',lastTrack=null;
 function price(product){return Math.min.apply(null,(product.variants||[]).filter(function(v){return v.available}).map(function(v){return Number(v.price)}))}
 function eligible(cart){
   var amount=cart.items.reduce(function(sum,item){return sum+(item.requires_shipping?item.final_line_price:0)},0);
   return Math.max(0,amount-(cart.cart_level_discount_applications||[]).reduce(function(sum,discount){return sum+Number(discount.total_allocated_amount||discount.discount_application&&discount.discount_application.total_allocated_amount||0)},0));
 }
 function choose(cart,config,related){
   var excluded=new Set(cart.items.map(function(item){return String(item.product_id)})),seen=new Set(),chosen=[];
   var subtotal=eligible(cart),gap=Math.max(0,config.threshold-subtotal);
   var close=cart.requires_shipping&&config.goalEnabled&&gap>0&&gap<=config.threshold*config.closePercent/100;
   function valid(p){return p&&p.available&&!excluded.has(String(p.id))&&Number.isFinite(price(p))&&price(p)>0}
   function add(products,goal,limit){products.forEach(function(p){if(chosen.length>=limit||!valid(p)||seen.has(String(p.id)))return;seen.add(String(p.id));chosen.push({product:p,goal:goal})})}
   if(close)add(config.addons.filter(function(p){return valid(p)&&p.requires_shipping!==false&&(p.variants||[]).filter(function(v){return v.available}).every(function(v){return v.requires_shipping!==false})&&price(p)>=gap&&price(p)<=config.threshold*config.closePercent/100}).sort(function(a,b){return price(a)-price(b)}),true,2);
   var hasGoal=chosen.length>0;
   add(config.pairs,false,6);add(related,false,6);add(config.fallback,false,6);
   return {items:chosen,gap:gap,hasGoal:hasGoal};
 }
 function el(tag,cls,text){var n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;}
 function getJson(url){return fetch(url,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw Error('Shopify '+r.status);return r.json();});}
 function build(product,cartIds){
  if(!product||!product.available||cartIds.has(String(product.id)))return null;
  var variants=product.variants||[],first=variants.find(function(v){return v.available;});
  if(!first)return null;
  var root=el('div','sa-reco'),image=el('div','sa-reco__image'),link=el('a');
  link.href=product.url||('/products/'+encodeURIComponent(product.handle));
  var img=el('img');img.src=thumbnail(product.featured_image,400);img.alt=product.title||'';img.loading='eager';img.decoding='async';img.width=400;img.height=500;
  link.appendChild(img);image.appendChild(link);
  if(variants.length===1){
   var form=el('product-form','sa-reco__form'),nativeForm=el('form');nativeForm.method='post';nativeForm.action=rootUrl+'cart/add';
   [['id',first.id],['quantity',1],['on_success','force_open_drawer']].forEach(function(pair){var input=el('input');input.type='hidden';input.name=pair[0];input.value=pair[1];nativeForm.appendChild(input);});
   var plus=el('button','sa-reco__plus','+');plus.type='submit';plus.setAttribute('aria-label',labels.add_to_bag+' '+product.title);
   nativeForm.appendChild(plus);form.appendChild(nativeForm);image.appendChild(form);
  }else{
   var button=el('button','sa-reco__plus sa-reco__choose','+');button.type='button';button.setAttribute('aria-expanded','false');button.setAttribute('aria-label',labels.choose_size+' '+product.title);image.appendChild(button);
   var picker=el('div','sa-reco__picker');picker.hidden=true;
   var form=el('product-form','sa-reco__form'),nativeForm=el('form');nativeForm.method='post';nativeForm.action=rootUrl+'cart/add';
   var heading=el('div','sa-reco__picker-heading'),label=el('span','sa-reco__picker-label',labels.select_size),close=el('button','sa-reco__close','×');close.type='button';close.setAttribute('aria-label',labels.close_size);heading.appendChild(label);heading.appendChild(close);var selected=el('input');selected.type='hidden';selected.name='id';selected.value='';selected.required=true;
   var sizes=el('div','sa-reco__sizes');sizes.setAttribute('role','group');sizes.setAttribute('aria-label',labels.choose_size);
   variants.forEach(function(v){var option=el('button','sa-reco__size'+(v.available?'':' is-unavailable'),v.title);option.type='button';option.dataset.variantId=v.id;option.disabled=!v.available;option.setAttribute('aria-pressed','false');sizes.appendChild(option);});
   nativeForm.appendChild(heading);nativeForm.appendChild(selected);nativeForm.appendChild(sizes);
   [['quantity',1],['on_success','force_open_drawer']].forEach(function(pair){var input=el('input');input.type='hidden';input.name=pair[0];input.value=pair[1];nativeForm.appendChild(input);});
   var add=el('button','sa-reco__picker-add',labels.add_to_bag);add.type='submit';add.disabled=true;nativeForm.appendChild(add);form.appendChild(nativeForm);picker.appendChild(form);image.appendChild(picker);
  }
  root.appendChild(image);
  var title=el('a','sa-reco__title',product.title);title.href=link.href;root.appendChild(title);
  var priceElement=el('div','sa-reco__price');
  var cents=price(product);
  try{priceElement.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:window.Shopify&&Shopify.currency&&Shopify.currency.active||'GBP'}).format(cents/100);}catch(e){priceElement.textContent=(cents/100).toFixed(2);}
  root.appendChild(priceElement);return root;
 }

 function thumbnail(source,width){
   try{var url=new URL(source||'',location.href);if(url.hostname==='cdn.shopify.com'||url.pathname.indexOf('/cdn/shop/')!==-1)url.searchParams.set('width',String(width));return url.href}catch(e){return source||''}
 }
 function warmImage(source,width){
   if(!source)return;
   var url=thumbnail(source,width);
   if(warmedImages.has(url))return;
   var img=new Image();img.decoding='async';img.src=url;warmedImages.set(url,img);
 }
 function warmLineImage(source){
   var size=matchMedia('(max-width:699px)').matches?70:120;
   var target=size*(window.devicePixelRatio||1);
   var width=[70,120,140,210,240,360].find(function(width){return width>=target})||360;
   warmImage(source,width);
 }
 function warmPageImages(){
   var script=document.querySelector('script[data-snrs-cart-product]');
   var image=script?.dataset.snrsCartImage;
   warmLineImage(image);
   document.querySelectorAll('[id^="snrs-look-list-"] img').forEach(function(img){warmImage(img.getAttribute('src'),400)});
 }
 function relatedRequest(id,currency){
   var key=currency+':'+id;
   if(!cache.has(key))cache.set(key,getJson(rootUrl+'recommendations/products.json?product_id='+id+'&limit=10&intent=related').then(function(result){
     var products=result.products||[];resolved.set(key,products);products.filter(function(p){return p.available}).slice(0,6).forEach(function(p){warmImage(p.featured_image,400)});return products;
   }).catch(function(){cache.delete(key);return []}));
   return cache.get(key);
 }
 function prime(cart){
   var currency=cart.currency||(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'GBP';
   var ids=(cart.items||[]).map(function(item){return item.product_id});
   var pageProduct=document.querySelector('script[data-snrs-cart-product]')?.dataset.snrsCartProduct;
   if(pageProduct)ids.push(pageProduct);
   ids.filter(function(id,index,all){return all.indexOf(id)===index}).slice(0,5).forEach(function(id){relatedRequest(id,currency)});
 }
 function refresh(drawer,cart){
   var section=(drawer||document.getElementById('cart-drawer'))?.querySelector('[data-snrs-cart-recommendations]');
   var track=section&&section.querySelector('.sa-reco-carousel'),data=section&&section.querySelector('[data-snrs-cart-recommendation-data]');
   if(!track||!data||!cart||!cart.item_count)return;
   var config;
   try{config=JSON.parse(data.textContent)}catch(e){return}
   generation++;
   labels=config.labels;
   var key=JSON.stringify([cart.items.map(function(i){return [i.product_id,i.variant_id,i.quantity,i.final_line_price]}),cart.total_price,cart.currency,config]);
   if(key===lastKey&&track===lastTrack)return;
   var related=cart.items.map(function(i){return i.product_id}).filter(function(id,index,ids){return ids.indexOf(id)===index}).slice(0,4).flatMap(function(id){return resolved.get(cart.currency+':'+id)||[]});
   var selected=choose(cart,config,related),ids=new Set(cart.items.map(function(i){return String(i.product_id)}));
   var cards=selected.items.map(function(item){
     var card=build(item.product,ids);
     if(card&&item.goal){card.dataset.shippingGoal='true';var badge=el('div','snrs-cart-goal-badge',config.labels.goal_badge);card.appendChild(badge)}
     return card;
   }).filter(Boolean);
   section.hidden=!cards.length;
   if(cards.length){track.replaceChildren.apply(track,cards);track.scrollLeft=0;section.classList.add('snrs-recommendations-ready');}
   var note=section.querySelector('[data-snrs-cart-goal-note]');
   if(note){note.hidden=!selected.hasGoal;note.textContent=selected.hasGoal?config.labels.goal_note.replace('[amount]',new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:cart.currency}).format(selected.gap/100)):'';}
   lastKey=key;lastTrack=track;
   prime(cart);
 }
 window.snrsPrepareCartRecommendations=refresh;
 function initial(){
   warmPageImages();
   var version=generation;
   getJson(rootUrl+'cart.js').then(function(cart){
     prime(cart);
     var drawer=document.getElementById('cart-drawer');
     if(version===generation&&drawer&&!drawer.hasAttribute('open'))refresh(drawer,cart);
   }).catch(function(){});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initial,{once:true});
 else initial();
 document.addEventListener('variant:change',function(event){var image=event.detail?.variant?.featured_image?.src;warmLineImage(image)});
 document.addEventListener('variant:add',function(event){if(event.detail&&event.detail.cart)prime(event.detail.cart)});
 document.addEventListener('shopify:section:load',function(event){if(event.target.querySelector('cart-drawer'))initial();});
})();
